import styled from "styled-components";

export const ShowInClientPortal = styled.div`
    ${props => props.isClientPortal && "visibility: visible;"}
    ${props => props.isClientPortal && "font-size: 80%;"}
`;
